/*
 * @Description:提供税筹结构和参与方返回业务说明（仕雄后端只反税筹结构，参与方和企业名称【工业，服务商，供应商】，业务说明要前端进行匹配） 各端展示内容不一致businessDescMap有差异
 * @Date: 2023-08-22 10:49:22
 */

/*
  换位符标记
  $ASP => ASP企业名称
  $GONGYE => 工业企业名称
  $GYS => 供应商企业名称
*/
/*
  税筹结构:{
    参与方:[
      ...业务说明
    ]
  }
*/
export const businessDescMap = {
  '1': {
    '1': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
      '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
      '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
      '发起方$GONGYE与服务商$ASP线下签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '平台向服务商$ASP开放平台准入合格的供应商信息；',
      '服务商$ASP对供应商进行遴选；',
      '服务商$ASP选择与供应商$GYS合作；',
      '供应商$GYS确认与服务商$ASP合作；',
      '供应商$GYS与服务商$ASP签署合作协议；',
      '服务商$ASP将本项目转包给供应商$GYS；',
      '供应商$GYS负责招募合格服务者，并将本项目分包给服务者；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '供应商$GYS对服务结果进行采购；',
      '服务商$ASP对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与服务商$ASP完成服务费结算；',
      '服务商$ASP与供应商$GYS完成服务费结算；',
      '供应商$GYS与服务者完成服务费结算；'
    ],
    '13': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
      '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
      '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
      '发起方$GONGYE与服务商$ASP线下签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '平台向服务商$ASP开放平台准入合格的供应商信息；',
      '服务商$ASP对供应商进行遴选；',
      '服务商$ASP选择与供应商$GYS合作；',
      '供应商$GYS确认与服务商$ASP合作；',
      '供应商$GYS与服务商$ASP签署合作协议；',
      '服务商$ASP将本项目转包给供应商$GYS；',
      '供应商$GYS负责招募合格服务者，并将本项目分包给服务者；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '供应商$GYS对服务结果进行采购；',
      '服务商$ASP对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与服务商$ASP完成服务费结算；',
      '服务商$ASP与供应商$GYS完成服务费结算；',
      '供应商$GYS与服务者完成服务费结算；'
    ]
  },
  '3': {
    '1': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
      '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
      '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
      '发起方$GONGYE与服务商$ASP线下签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '平台向服务商$ASP开放平台准入合格的供应商信息；',
      '服务商$ASP对供应商进行遴选；',
      '服务商$ASP选择与供应商$GYS合作；',
      '供应商$GYS确认与服务商$ASP合作；',
      '供应商$GYS与服务商$ASP签署代发协议；',
      '服务商$ASP将本项目转包给平台上的服务者；',
      '服务商$ASP与服务者完成服务协议的电子签署；',
      '服务者与供应商$GYS完成代发协议的电子签署；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '供应商$GYS对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与$ASP完成服务费结算；',
      '供应商$GYS对服务结算进行确认；',
      '服务商$ASP通过供应商$GYS代发服务费的方式与服务者完成服务费结算；'
    ],
    '13': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
      '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
      '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
      '发起方$GONGYE与服务商$ASP线下签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '平台向服务商$ASP开放平台准入合格的供应商信息；',
      '服务商$ASP对供应商进行遴选；',
      '服务商$ASP选择与供应商$GYS合作；',
      '供应商$GYS确认与服务商$ASP合作；',
      '供应商$GYS与服务商$ASP签署代发协议；',
      '服务商$ASP将本项目转包给平台上的服务者；',
      '服务商$ASP与服务者完成服务协议的电子签署；',
      '服务者与供应商$GYS完成代发协议的电子签署；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '供应商$GYS对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与$ASP完成服务费结算；',
      '供应商$GYS对服务结算进行确认；',
      '服务商$ASP通过供应商$GYS代发服务费的方式与服务者完成服务费结算；'
    ]
  },
  '4': {
    '7': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '发起方$GONGYE申请入驻向日葵平台；',
      '发起方$GONGYE符合平台准入标准，入驻成功；',
      '平台向发起方$GONGYE开放平台官方认证运营基地信息；',
      '发起方$GONGYE对服务商进行遴选、考察、准入；',
      '服务商$ASP通过发起方$GONGYE准入；',
      '服务商$ASP确认与发起方$GONGYE合作；',
      '发起方$GONGYE与服务商$ASP签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '服务商$ASP负责招募合格服务者，并将项目分包给服务者；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '服务商$ASP对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与服务商$ASP完成服务费结算；',
      '服务商$ASP与服务者完成服务费结算；'
    ]
  },
  '5': {
    // 园区个体 gtType = 3
    '3': {
      '10': [
        '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
        '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
        '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
        '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
        '发起方$GONGYE与服务商$ASP线下签署合作协议；',
        '发起方$GONGYE将本项目转包给服务商$ASP；',
        '服务商$ASP将本项目转包给平台上的服务者；',
        '服务商$ASP与服务者完成服务协议的电子签署；',
        '服务者在向日葵联盟小程序or APP上提交服务结果；',
        '服务商$ASP对服务结果进行审核；',
        '发起方$GONGYE对服务结果进行确认；',
        '发起方$GONGYE与服务商$ASP完成服务费结算；',
        '服务商$ASP与服务者完成服务费结算；',
        '服务者支付代理服务公司服务费及个体税金；'
      ]
    },
    // 普通个体 gtType = 2
    '2': {
      '10': [
        '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
        '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
        '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
        '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
        '发起方$GONGYE与服务商$ASP线下签署合作协议；',
        '发起方$GONGYE将本项目转包给服务商$ASP；',
        '服务商$ASP将本项目转包给平台上的服务者；',
        '服务者在向日葵联盟小程序or APP上提交服务结果；',
        '服务商$ASP对服务结果进行审核；',
        '发起方$GONGYE对服务结果进行确认；',
        '发起方$GONGYE与服务商$ASP完成服务费结算；',
        '服务商$ASP与服务者完成服务费结算；'
      ]
    }
  },
  '6': {
    '4': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
      '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
      '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
      '发起方$GONGYE与服务商$ASP线下签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '服务商$ASP将本项目转包给平台上的服务者；',
      '服务商$ASP与服务者完成服务协议的电子签署；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '服务商$ASP对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与服务商$ASP完成服务费结算；',
      '服务商$ASP与服务者完成服务费结算；',
      '服务者支付平台（代收代付）代开发票服务费及个人税金；'
    ]
  },
  '2': {
    '4': [
      '发起方$GONGYE认可向日葵平台交易规则，准入向日葵平台；',
      '服务商$ASP是发起方$GONGYE合格服务商，双方通过招商于线下确认业务合作关系；',
      '发起方$GONGYE、服务商$ASP申请入驻向日葵平台；',
      '发起方$GONGYE、服务商$ASP符合平台准入标准，入驻成功；',
      '发起方$GONGYE与服务商$ASP线下签署合作协议；',
      '发起方$GONGYE将本项目转包给服务商$ASP；',
      '服务商$ASP将本项目转包给平台上的服务者；',
      '服务商$ASP与服务者完成服务协议的电子签署；',
      '服务者在向日葵联盟小程序or APP上提交服务结果；',
      '服务商$ASP对服务结果进行审核；',
      '发起方$GONGYE对服务结果进行确认；',
      '发起方$GONGYE与服务商$ASP完成服务费结算；',
      '服务商$ASP与服务者完成服务费结算，并支付平台（代收代付）代开发票服务费及个人税金；'
    ]
  }
};
/**
 * @description: 提供税筹结构和参与方返回业务说明
 * @param {number} taxPattern 税筹结构
 * @param {number} patternType 参与方
 * @param {number} gtType 个体类型
 * @param {string} gongyeName 工业名称
 * @param {string} aspName 服务商名称
 * @param {string} supplierName 供应商名称
 * @return {string[]} 业务说明
 */
export const getBusinessDesc = ({
  taxPattern,
  patternType,
  gtType = 0,
  gongyeName,
  aspName,
  supplierName
}) => {
  let desc = [];
  if (gtType) {
    desc = businessDescMap[taxPattern][gtType][patternType];
  } else {
    desc = businessDescMap[taxPattern][patternType];
  }
  desc = desc.map(item =>
    item
      .replace('$ASP', `<span style='color:#3296fb'>${aspName || ''}</span>`)
      .replace(
        '$GONGYE',
        `<span style='color:#3296fb'>${gongyeName || ''}</span>`
      )
      .replace(
        '$GYS',
        `<span style='color:#3296fb'>${supplierName || ''}</span>`
      )
  );
  return desc;
};
